
export { LucideIcon } from "/codebuild/output/src3838206175/src/packages/shared-components/src/components/LucideIcon.tsx"